import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, Provider, ReactReduxContext } from 'react-redux';
import moment from 'moment';
import Avatar from 'material-ui/Avatar';
import ActionInfo from 'material-ui/svg-icons/action/info';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import LinkIcon from 'material-ui/svg-icons/content/link';
import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import RaisedButton from 'material-ui/RaisedButton';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import Subheader from 'material-ui/Subheader';
import TextField from 'material-ui/TextField';
import xLogo from '../../../assets/x-logo.svg';
import { startCase, kebabCase } from 'lodash';
import makeSelectable, { wrapState } from '../../../helpers/makeMultiSelectList';
import { makeInitials } from '../../../helpers/util';
import { loadBusinessInfo } from '../../../redux/modules/googleMyBusiness';
import UserEmailSelector from '../../UserEmailSelector/UserEmailSelector';
import FacebookAdAccountConnectionModal from '../FacebookAdAccountConnectionModal';
import GMBSettings from './GMBSettings';
import { Modal, Spinner, Tooltip } from 'components';
import { FacebookPixelSetup as _FacebookPixelSetup } from 'containers';
import gmbLogo from '../../../assets/google-my-business-logo.svg';
import igLogo from '../../../assets/instagram-logo.svg';
import fbLogo from '../../../assets/facebook-logo.svg';
import liLogo from '../../../assets/linkedin-icon.svg';
import styles from '../styles.scss';
var SelectableList = makeSelectable(List);
SelectableList = wrapState(SelectableList);
var platformSettings = {
  facebook: {
    iconRender: function iconRender() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.platformIconWrap
      }, /*#__PURE__*/React.createElement("img", {
        src: fbLogo
      }));
    },
    brandColor: '#1877f2'
  },
  instagram: {
    iconRender: function iconRender() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.platformIconWrap
      }, /*#__PURE__*/React.createElement("img", {
        src: igLogo
      }));
    },
    brandColor: '#cd486b'
  },
  linkedin: {
    iconRender: function iconRender() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.platformIconWrap
      }, /*#__PURE__*/React.createElement("img", {
        src: liLogo
      }));
    },
    brandColor: '#0077B5'
  },
  twitter: {
    iconRender: function iconRender() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.platformIconWrap
      }, /*#__PURE__*/React.createElement("img", {
        src: xLogo
      }));
    }
  },
  pinterest: {
    iconClassName: 'fa fa-pinterest',
    brandColor: '#bd081c'
  },
  google: {
    iconClassName: 'fa fa-google',
    brandColor: '#4285f4'
  },
  googlemybusiness: {
    iconRender: function iconRender() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.platformIconWrap
      }, /*#__PURE__*/React.createElement("img", {
        src: gmbLogo
      }));
    },
    brandColor: '#4989f5'
  },
  "default": {
    iconClassName: ''
  }
};
export default function SocialPlatformSection(_ref) {
  var platform = _ref.platform,
      displayName = _ref.displayName,
      children = _ref.children;
  var settings = platformSettings.hasOwnProperty(platform) ? platformSettings[platform] : platformSettings["default"];
  return /*#__PURE__*/React.createElement("div", {
    id: "test-socialaccount-".concat(kebabCase(platform)),
    className: styles.platformSection,
    style: {
      color: settings.brandColor,
      padding: '0 16px 32px'
    }
  }, !!settings.iconRender ? settings.iconRender({
    platform: platform,
    displayName: displayName
  }) : /*#__PURE__*/React.createElement("i", {
    className: settings.iconClassName,
    style: {
      fontSize: '50px',
      textAlign: 'center',
      width: '100%'
    }
  }), /*#__PURE__*/React.createElement("h3", {
    className: styles.network,
    style: {
      textAlign: 'center'
    }
  }, displayName || startCase(platform)), /*#__PURE__*/React.createElement("div", {
    className: styles.platformSectionContentWrap
  }, children));
}
export var FacebookConnect = /*#__PURE__*/function (_React$Component) {
  _inherits(FacebookConnect, _React$Component);

  var _super = _createSuper(FacebookConnect);

  function FacebookConnect() {
    var _this;

    _classCallCheck(this, FacebookConnect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      settingsExpanded: false
    });

    return _this;
  }

  _createClass(FacebookConnect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      console.log('props = ', this.props);

      var _this$props = this.props,
          platform = _this$props.platform,
          displayName = _this$props.displayName,
          accounts = _this$props.accounts,
          onRequestConnection = _this$props.onRequestConnection,
          rest = _objectWithoutProperties(_this$props, ["platform", "displayName", "accounts", "onRequestConnection"]);

      var settings = platformSettings.hasOwnProperty(platform) ? platformSettings[platform] : platformSettings["default"];

      if (accounts.length === 0) {
        return /*#__PURE__*/React.createElement("a", {
          className: styles.primaryButton,
          style: {
            background: settings.brandColor
          },
          onClick: function onClick() {
            return onRequestConnection('Facebook page');
          }
        }, "Connect");
      }

      var fbWithAdAccount = accounts ? accounts.find(function (a) {
        return a.FacebookAdAccount && a.FacebookAdAccount.adAccountId;
      }) : null;
      var isLoadingFeatures = fbWithAdAccount && fbWithAdAccount.features && fbWithAdAccount.features.loading === true;
      var isFeaturesDisabled = !fbWithAdAccount || isLoadingFeatures;
      var hasLeadsConnected = !isLoadingFeatures && !isFeaturesDisabled && fbWithAdAccount && fbWithAdAccount.features && fbWithAdAccount.features.webhookSubscriptions && fbWithAdAccount.features.webhookSubscriptions.some(function (sub) {
        return "".concat(sub.id) === '465979560146592' || "".concat(sub.id) === '367116796742921';
      });
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ConnectedAccount, _extends({
        platform: platform,
        accounts: accounts,
        onRequestConnection: onRequestConnection
      }, rest)), !!accounts && accounts.length > 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 240
        }
      }, /*#__PURE__*/React.createElement(Card, {
        style: this.state.settingsExpanded ? {} : {
          boxShadow: 'none'
        },
        onExpandChange: function onExpandChange(newExpandedState) {
          _this2.setState({
            settingsExpanded: newExpandedState
          });
        }
      }, /*#__PURE__*/React.createElement(CardHeader, {
        title: "Settings",
        actAsExpander: true,
        showExpandableButton: true
      }), /*#__PURE__*/React.createElement(CardText, {
        expandable: true
      }, /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(ListItem, {
        primaryText: fbWithAdAccount ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
          className: "icon ion-ios-checkmark-empty ".concat(styles.enableCheckIcon)
        }), " Active Ad Account", rest.user.isLikeableLocal ? "\n(".concat("".concat(fbWithAdAccount.FacebookAdAccount.adAccountId).replace('act_', ''), ")") : '') : /*#__PURE__*/React.createElement(RaisedButton, {
          primary: true,
          label: "Enable Ads",
          onClick: function onClick() {
            rest.requestBusinessManagerPageAccess(accounts[0].id);
          },
          shortButton: true,
          style: {
            width: '100%',
            marginBottom: 20
          }
        }),
        style: fbWithAdAccount ? {
          color: 'green'
        } : {},
        disabled: true
      }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ListItem, {
        onClick: function onClick() {
          if (!(isFeaturesDisabled || hasLeadsConnected)) {
            rest.subscribeAccountToWebhooks(fbWithAdAccount.id);
          }
        },
        disabled: isFeaturesDisabled || hasLeadsConnected,
        primaryText: hasLeadsConnected ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
          className: "icon ion-ios-checkmark-empty ".concat(styles.enableCheckIcon)
        }), " Lead Notifications") : 'Lead Notifications',
        rightAvatar: !isLoadingFeatures ? !hasLeadsConnected ? /*#__PURE__*/React.createElement(LinkIcon, {
          style: _objectSpread({
            marginTop: 10
          }, isFeaturesDisabled ? {
            color: 'silver'
          } : {})
        }) : null : /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin",
          style: _objectSpread({
            fontSize: 18,
            marginTop: 10
          }, isFeaturesDisabled ? {
            color: 'silver'
          } : {})
        }),
        style: function () {
          if (isFeaturesDisabled) {
            return {
              color: 'silver'
            };
          }

          if (hasLeadsConnected) {
            return {
              color: 'green'
            };
          }

          return {};
        }()
      }), /*#__PURE__*/React.createElement(ListItem, {
        onClick: function onClick() {
          !!rest.handleFacebookPixelTracking && rest.handleFacebookPixelTracking();
        },
        disabled: false,
        primaryText: 'Pixel Tracking',
        rightAvatar: /*#__PURE__*/React.createElement(SettingsIcon, {
          style: _objectSpread({
            marginTop: 10
          }, !fbWithAdAccount ? {
            color: 'silver'
          } : {})
        }),
        style: !fbWithAdAccount ? {
          color: 'silver'
        } : {}
      }))))));
    }
  }]);

  return FacebookConnect;
}(React.Component);
export function TwitterConnect(_ref2) {
  var platform = _ref2.platform,
      displayName = _ref2.displayName,
      accounts = _ref2.accounts,
      onRequestConnection = _ref2.onRequestConnection,
      rest = _objectWithoutProperties(_ref2, ["platform", "displayName", "accounts", "onRequestConnection"]);

  var settings = platformSettings.hasOwnProperty(platform) ? platformSettings[platform] : platformSettings["default"];

  if (accounts.length === 0) {
    return /*#__PURE__*/React.createElement("a", {
      className: styles.primaryButton,
      style: {
        background: settings.brandColor
      },
      onClick: function onClick() {
        return onRequestConnection('Twitter');
      }
    }, "Connect");
  }

  return /*#__PURE__*/React.createElement(ConnectedAccount, _extends({
    platform: platform,
    accounts: accounts,
    onRequestConnection: onRequestConnection
  }, rest));
}
export function InstagramConnect(_ref3) {
  var platform = _ref3.platform,
      displayName = _ref3.displayName,
      accounts = _ref3.accounts,
      handleRequestReminderOnlyConnection = _ref3.handleRequestReminderOnlyConnection,
      rest = _objectWithoutProperties(_ref3, ["platform", "displayName", "accounts", "handleRequestReminderOnlyConnection"]);

  var settings = platformSettings.hasOwnProperty(platform) ? platformSettings[platform] : platformSettings["default"];
  return /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, accounts.length > 0 && /*#__PURE__*/React.createElement(ConnectedAccount, _extends({
    platform: platform,
    accounts: accounts
  }, rest)), !_toConsumableArray(accounts).find(function (a) {
    return a.platform === 'Instagram';
  }) ? /*#__PURE__*/React.createElement("a", {
    className: styles.primaryButton,
    style: {
      background: settings.brandColor
    },
    onClick: function onClick() {
      return handleRequestReminderOnlyConnection('Instagram');
    }
  }, "Create Reminder") : null, !accounts.find(function (a) {
    return a.platform === 'Instagram[page_connected]';
  }) ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.primaryButton,
    style: {
      background: settings.brandColor
    },
    onClick: function onClick() {
      return rest.openPageInstagramConnection();
    }
  }, "Enable Ads")) : null);
}
export function LinkedInConnect(_ref4) {
  var platform = _ref4.platform,
      displayName = _ref4.displayName,
      accounts = _ref4.accounts,
      onRequestConnection = _ref4.onRequestConnection,
      rest = _objectWithoutProperties(_ref4, ["platform", "displayName", "accounts", "onRequestConnection"]);

  var settings = platformSettings.hasOwnProperty(platform) ? platformSettings[platform] : platformSettings["default"];
  return /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, accounts && accounts.length > 0 && /*#__PURE__*/React.createElement(ConnectedAccount, _extends({
    platform: platform,
    accounts: accounts,
    onRequestConnection: onRequestConnection
  }, rest)), (!accounts || !accounts.find(function (a) {
    return a.platform === 'LinkedIn profile';
  })) && /*#__PURE__*/React.createElement("a", {
    className: styles.primaryButton,
    style: {
      background: settings.brandColor
    },
    onClick: function onClick() {
      return onRequestConnection('LinkedIn profile');
    }
  }, "Connect Profile"), (!accounts || !accounts.find(function (a) {
    return a.platform === 'LinkedIn company';
  })) && /*#__PURE__*/React.createElement("a", {
    className: styles.primaryButton,
    style: {
      background: settings.brandColor
    },
    onClick: function onClick() {
      return onRequestConnection('LinkedIn company');
    }
  }, "Connect Company"));
}
export function ConnectedAccount(_ref5) {
  var platform = _ref5.platform,
      accounts = _ref5.accounts,
      handleDelete = _ref5.handleDelete,
      onRequestConnection = _ref5.onRequestConnection,
      handlePostReminderSettings = _ref5.handlePostReminderSettings,
      handleAccountSettings = _ref5.handleAccountSettings;
  return /*#__PURE__*/React.createElement(List, null, accounts.map(function (account) {
    var _account$PostReminder;

    var tokenExpired = moment(account.tokenValidUntil).isBefore(moment());
    var needsTokenRefresh = moment(account.tokenValidUntil).isBefore(moment().add(10, 'days'));

    if (account.platform == "Twitter") {
      needsTokenRefresh = false;
    }

    return /*#__PURE__*/React.createElement(ListItem, {
      style: {
        fontWeight: 'bold'
      },
      secondaryTextLines: 2,
      secondaryText: function () {
        var str = "".concat(account.platform);

        if (str === 'Twitter') {
          str = 'X (Twitter)';
        }

        if (str === 'Google my business') {
          str = 'Google Business Profile';
        }

        if (account.platform === 'Instagram[page_connected]') {
          str = ['Page-Connected Instagram ', /*#__PURE__*/React.createElement(Tooltip, {
            key: "igpageconnectedtooltip",
            name: "igpageconnectedtooltip",
            message: /*#__PURE__*/React.createElement("span", null, "This Instagram Account is linked to your currently connected Facebook page.", /*#__PURE__*/React.createElement("br", null), "This account can have ads created for it.")
          })];
        }

        if (account.PostReminders && account.PostReminders.length > 0) {
          str += ' post reminders';
        }

        return str;
      }(),
      disabled: true,
      key: account.id,
      leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
        src: account.avatarImageUrl,
        style: account.avatarImageUrl ? {
          backgroundColor: 'white'
        } : {}
      }, !account.avatarImageUrl ? makeInitials("".concat(account.username)) : null),
      rightIconButton: /*#__PURE__*/React.createElement(IconMenu, {
        iconButtonElement: /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(MoreVertIcon, {
          color: "rgb(110, 110, 110)"
        }))
      }, /*#__PURE__*/React.createElement(MenuItem, {
        onClick: function onClick() {
          window.open(account.link);
        }
      }, "View"), (account.PostReminders && account.PostReminders.length > 0 || ['Instagram[page_connected]', 'Google my business'].includes(account.platform)) && /*#__PURE__*/React.createElement(MenuItem, {
        onClick: function onClick() {
          if (account.platform === 'Instagram[page_connected]') {
            window.open("https://www.facebook.com/".concat(account.ownerFacebookPageId, "/settings/?tab=instagram_management"));
          } else if (account.PostReminders && account.PostReminders.length > 0) {
            handlePostReminderSettings(account);
          } else if (account.platform === 'Google my business') {
            handleAccountSettings && handleAccountSettings(account);
          }
        }
      }, account.platform === 'Google my business' ? 'Details' : 'Settings'), !((_account$PostReminder = account.PostReminders) !== null && _account$PostReminder !== void 0 && _account$PostReminder.length) && account.platform !== 'Instagram[page_connected]' && /*#__PURE__*/React.createElement(MenuItem, {
        onClick: function onClick() {
          return onRequestConnection(account.platform, true);
        }
      }, "Reconnect"), /*#__PURE__*/React.createElement(MenuItem, {
        onClick: function onClick() {
          if (account.platform === 'Instagram[page_connected]') {
            if (confirm('Because this account is connected to your Facebok page, any changes must be made in Facebook. Bear in mind, removing this account will restrict you from creating advertisements for Instagram. Would you like to navigate to Facebook now?')) {
              window.open("https://www.facebook.com/".concat(account.ownerFacebookPageId, "/settings/?tab=instagram_management"));
            }
          } else if (handleDelete) {
            handleDelete(account);
          }
        }
      }, "Delete"))
    }, needsTokenRefresh && /*#__PURE__*/React.createElement("i", {
      className: "fa fa-exclamation-triangle",
      style: {
        color: tokenExpired ? '#e74c3c' : '#f1c40f',
        position: 'absolute',
        left: -6,
        top: 28
      }
    }), needsTokenRefresh && /*#__PURE__*/React.createElement(Tooltip, {
      key: "".concat(account.platformId, "_token_refresh"),
      name: "".concat(account.platformId, "_token_refresh"),
      message: tokenExpired ? /*#__PURE__*/React.createElement("span", null, "This account has an expired token.", /*#__PURE__*/React.createElement("br", null), "You need to reconnect it to be able to post.", /*#__PURE__*/React.createElement("br", null), "Click the three dots next the account name and select Reconnect.") : /*#__PURE__*/React.createElement("span", null, "This account has a token that will expire soon.", /*#__PURE__*/React.createElement("br", null), "You need to reconnect it or you will be unable to post soon.", /*#__PURE__*/React.createElement("br", null), "Click the three dots next the account name and select Reconnect.")
    }), ['twitter'].includes(platform) && '@', account.username);
  }));
}
export function GoogleMyBusinessConnect(_ref6) {
  var platform = _ref6.platform,
      displayName = _ref6.displayName,
      accounts = _ref6.accounts,
      onRequestConnection = _ref6.onRequestConnection,
      onClickSettings = _ref6.onClickSettings,
      rest = _objectWithoutProperties(_ref6, ["platform", "displayName", "accounts", "onRequestConnection", "onClickSettings"]);

  var settings = platformSettings.hasOwnProperty(platform) ? platformSettings[platform] : platformSettings["default"];

  if (accounts.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'rgb(97, 97, 97)'
      }
    }, /*#__PURE__*/React.createElement("a", {
      className: styles.primaryButton,
      style: {
        background: settings.brandColor
      },
      onClick: function onClick() {
        return onRequestConnection('Google my business');
      }
    }, "Connect"), /*#__PURE__*/React.createElement(Tooltip, {
      key: "gmbpageconnectedtooltip",
      name: "gmbpageconnectedtooltip",
      message: /*#__PURE__*/React.createElement("span", null, "You will only be able to connect Google Business Profile", /*#__PURE__*/React.createElement("br", null), " accounts that you have admin access to.")
    }));
  }

  return /*#__PURE__*/React.createElement(ConnectedAccount, _extends({
    platform: platform,
    accounts: accounts,
    onRequestConnection: onRequestConnection,
    handleAccountSettings: onClickSettings
  }, rest));
}
export var socialAccountsDialogs = {
  RemoveAccountDialog: function RemoveAccountDialog(_ref7) {
    var open = _ref7.open,
        onRequestClose = _ref7.onRequestClose,
        onFinish = _ref7.onFinish,
        disabled = _ref7.disabled;
    return /*#__PURE__*/React.createElement(Dialog, {
      actions: [/*#__PURE__*/React.createElement(RaisedButton, {
        id: "test-removecancel",
        key: "cancel",
        style: {
          marginRight: 24
        },
        label: "Cancel",
        onClick: onRequestClose
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        key: "confirm",
        label: "Remove Account",
        onClick: onFinish,
        disabled: disabled || false
      })],
      open: open,
      title: "Are You Sure?",
      onRequestClose: onRequestClose
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        color: 'black'
      }
    }, "Removing your social account will also remove any queued content."));
  },
  AccountSelectionDialog: function AccountSelectionDialog(_ref8) {
    var open = _ref8.open,
        onRequestClose = _ref8.onRequestClose,
        onFinish = _ref8.onFinish,
        disabled = _ref8.disabled,
        _ref8$searchTerm = _ref8.searchTerm,
        searchTerm = _ref8$searchTerm === void 0 ? '' : _ref8$searchTerm,
        handleSearchTermChange = _ref8.handleSearchTermChange,
        handleAccountSelected = _ref8.handleAccountSelected,
        _ref8$socialAccountLi = _ref8.socialAccountList,
        socialAccountList = _ref8$socialAccountLi === void 0 ? [] : _ref8$socialAccountLi;
    return /*#__PURE__*/React.createElement(Dialog, {
      actions: [/*#__PURE__*/React.createElement(RaisedButton, {
        key: "cancel",
        style: {
          marginRight: 24
        },
        label: "Cancel",
        onClick: onRequestClose
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        key: "confirm",
        label: "Submit",
        onClick: onFinish,
        disabled: disabled || false
      })],
      open: open,
      title: "Select An Account",
      onRequestClose: onRequestClose,
      autoScrollBodyContent: true,
      contentStyle: {
        transform: 'none'
      },
      repositionOnUpdate: false,
      style: {
        paddingTop: 16
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextField, {
      value: searchTerm,
      hintText: "Search",
      fullWidth: true,
      style: {
        marginBottom: 10,
        top: 0.25,
        zIndex: 999,
        background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 10%,rgba(255,255,255,1) 90%,rgba(0,0,0,0) 100%)',
        position: 'sticky'
      },
      onChange: handleSearchTermChange
    }), /*#__PURE__*/React.createElement(SelectableList, null, socialAccountList.map(function (_ref9) {
      var id = _ref9.id,
          name = _ref9.name,
          picture = _ref9.picture,
          _ref9$selected = _ref9.selected,
          selected = _ref9$selected === void 0 ? false : _ref9$selected;
      return /*#__PURE__*/React.createElement(ListItem, {
        key: id,
        onClick: function onClick() {
          handleAccountSelected(id);
        },
        value: id,
        primaryText: name,
        leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
          src: picture
        }, !picture ? makeInitials(name) : null)
      });
    }))));
  },
  FacebookPixelSetup: function FacebookPixelSetup(_ref10) {
    var open = _ref10.open,
        onRequestClose = _ref10.onRequestClose,
        step = _ref10.step,
        error = _ref10.error,
        disabled = _ref10.disabled,
        incrementStep = _ref10.incrementStep,
        decrementStep = _ref10.decrementStep,
        verifyPixel = _ref10.verifyPixel;
    return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
      return /*#__PURE__*/React.createElement(Dialog, {
        title: "Setup Facebook Pixel Tracking",
        titleStyle: {
          color: '#555555'
        },
        actions: [step !== 3 ? /*#__PURE__*/React.createElement(RaisedButton, {
          key: "cancelbtn",
          label: "Cancel",
          onClick: onRequestClose,
          style: {
            marginRight: 12
          }
        }) : null, step === 3 ? /*#__PURE__*/React.createElement(RaisedButton, {
          primary: true,
          key: "okbutton",
          label: "OK",
          onClick: onRequestClose
        }) : null, step > 1 && step !== 3 ? /*#__PURE__*/React.createElement(RaisedButton, {
          primary: true,
          key: "prevbtn",
          label: "Previous",
          onClick: decrementStep,
          style: {
            marginRight: 12
          }
        }) : null, step < 2 ? /*#__PURE__*/React.createElement(RaisedButton, {
          primary: true,
          key: "nextbtn",
          label: "Next",
          onClick: incrementStep
        }) : null, step === 2 ? /*#__PURE__*/React.createElement(RaisedButton, {
          primary: true,
          key: "verifybtn",
          label: "Verify",
          disabled: disabled,
          onClick: verifyPixel
        }) : null],
        autoScrollBodyContent: true,
        modal: true,
        open: open,
        onRequestClose: onRequestClose,
        bodyStyle: {
          color: '#717171',
          lineHeight: '24px'
        },
        contentStyle: {
          transform: 'none'
        },
        repositionOnUpdate: false,
        style: {
          paddingTop: 16
        }
      }, /*#__PURE__*/React.createElement(Provider, {
        store: ctx.store
      }, /*#__PURE__*/React.createElement(_FacebookPixelSetup, {
        step: step,
        error: error
      })));
    });
  },
  FacebookAdAccountConnection: function FacebookAdAccountConnection(_ref11) {
    var onRequestClose = _ref11.onRequestClose,
        open = _ref11.open,
        disabled = _ref11.disabled,
        onFinish = _ref11.onFinish,
        targetAccount = _ref11.targetAccount,
        openFacebook = _ref11.openFacebook,
        phaseIndex = _ref11.phaseIndex;
    return /*#__PURE__*/React.createElement(Dialog, {
      title: "Connect Facebook Ad Account",
      titleStyle: {
        color: '#555555'
      },
      actions: phaseIndex === 1 || phaseIndex === 2 ? [/*#__PURE__*/React.createElement(RaisedButton, {
        key: "phase1cancel",
        label: "Cancel",
        onClick: onRequestClose,
        style: {
          marginRight: 12
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        key: "phase1finish",
        label: "Finish",
        disabled: disabled,
        onClick: onFinish
      })] : [/*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        key: "phase0cancel",
        label: "Cancel",
        onClick: onRequestClose,
        style: {
          marginRight: 12
        }
      })],
      autoScrollBodyContent: true,
      modal: true,
      open: open,
      onRequestClose: onRequestClose,
      bodyStyle: {
        color: '#717171',
        lineHeight: '24px'
      },
      contentStyle: {
        transform: 'none'
      },
      repositionOnUpdate: false,
      style: {
        paddingTop: 16
      }
    }, /*#__PURE__*/React.createElement(FacebookAdAccountConnectionModal, {
      phase: phaseIndex,
      account: targetAccount,
      openFacebook: openFacebook
    }));
  },
  InstagramAdsConnection: function InstagramAdsConnection(_ref12) {
    var open = _ref12.open,
        step = _ref12.step,
        onRequestClose = _ref12.onRequestClose,
        openFacebook = _ref12.openFacebook,
        disabled = _ref12.disabled,
        instagramAccountData = _ref12.instagramAccountData,
        onFinish = _ref12.onFinish;
    return /*#__PURE__*/React.createElement(Dialog, {
      title: "Connect Instagram Ads Account",
      titleStyle: {
        color: '#555555'
      },
      actions: [/*#__PURE__*/React.createElement(RaisedButton, {
        key: "cancelbtn",
        label: "Cancel",
        onClick: function onClick() {
          return onRequestClose();
        },
        style: {
          marginRight: 12,
          "float": 'left'
        }
      }), step === 1 ? /*#__PURE__*/React.createElement(RaisedButton, {
        key: "setupgray",
        label: "Setup in Facebook",
        onClick: function onClick() {
          return openFacebook();
        }
      }) : /*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        key: "setupsecondary",
        label: "Setup in Facebook",
        onClick: function onClick() {
          return openFacebook();
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        key: "completebtn",
        label: !disabled ? 'Complete Setup' : /*#__PURE__*/React.createElement("i", {
          style: {
            fontSize: 20
          },
          className: "fa fa-spinner fa-spin"
        }),
        style: {
          marginLeft: 10
        },
        disabled: step !== 1 || disabled,
        onClick: function onClick() {
          return onFinish();
        }
      })],
      autoScrollBodyContent: true,
      modal: true,
      open: open,
      onRequestClose: onRequestClose,
      bodyStyle: {
        color: '#717171',
        lineHeight: '24px'
      },
      contentStyle: {
        transform: 'none'
      },
      repositionOnUpdate: false,
      style: {
        paddingTop: 16
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        padding: 20
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center',
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: 'fa fa-instagram',
      style: {
        fontSize: '50px',
        color: "".concat(platformSettings.instagram.brandColor),
        margin: 4
      }
    }), /*#__PURE__*/React.createElement("i", {
      className: 'fa fa-arrow-right',
      style: {
        fontSize: 30,
        lineHeight: '50px',
        verticalAlign: 'top',
        paddingLeft: 5,
        paddingRight: 5,
        marginTop: 2
      }
    }), /*#__PURE__*/React.createElement("i", {
      className: 'fa fa-facebook-square',
      style: {
        fontSize: '50px',
        color: "".concat(platformSettings.facebook.brandColor),
        margin: 4
      }
    })), /*#__PURE__*/React.createElement("p", null, "To connect your Instagram account, it must first be connected to your Facebook page through Facebook.com. This can be done in 3 easy steps!"), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement("li", null, "Click below to be brought to Facebook.com."), /*#__PURE__*/React.createElement("li", null, "Click the log in to Instagram button"), /*#__PURE__*/React.createElement("li", null, "Once your Instagram account is connected to your Facebook page, return to this page to complete the setup.")), instagramAccountData && instagramAccountData.attempted && !instagramAccountData.value && /*#__PURE__*/React.createElement("p", {
      style: {
        fontWeight: 'bold',
        color: '#ff6464'
      }
    }, "We couldn't find your Instagram account. Please make sure your Instagram account is connected to your Facebook page.")));
  },
  InstagramReminderSetup: function InstagramReminderSetup(_ref13) {
    var open = _ref13.open,
        loading = _ref13.loading,
        onRequestClose = _ref13.onRequestClose,
        pageInstagram = _ref13.pageInstagram,
        step = _ref13.step,
        incrementStep = _ref13.incrementStep,
        decrementStep = _ref13.decrementStep,
        skipToStep = _ref13.skipToStep,
        accountValue = _ref13.accountValue,
        onChangeAccount = _ref13.onChangeAccount,
        handleAccountLoad = _ref13.handleAccountLoad,
        enteredAccount = _ref13.enteredAccount,
        onFinish = _ref13.onFinish;
    return /*#__PURE__*/React.createElement(Dialog, {
      contentStyle: {
        paddingTop: 0,
        transform: 'none'
      },
      repositionOnUpdate: false,
      style: {
        paddingTop: 16
      },
      title: "Instagram Post Reminders",
      titleStyle: {
        color: '#555555'
      },
      actions: [/*#__PURE__*/React.createElement(RaisedButton, {
        key: "closebtn",
        label: "Close",
        onClick: function onClick() {
          return onRequestClose();
        },
        style: {
          marginRight: 12
        }
      }), step === 0 && /*#__PURE__*/React.createElement(RaisedButton, {
        key: "getstartedbtn",
        label: "Get Started",
        onClick: function onClick() {
          return incrementStep();
        }
      }), step !== 0 && /*#__PURE__*/React.createElement(RaisedButton, {
        key: "prevbtn",
        label: "Previous",
        onClick: function onClick() {
          return decrementStep();
        },
        style: {
          marginRight: 12
        }
      }), step !== 0 && !(step === 1 && !!pageInstagram) && /*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        disabled: loading,
        key: "nextbtn",
        label: !loading ? step === 3 && !!enteredAccount ? 'Confirm' : 'Next' : /*#__PURE__*/React.createElement("i", {
          style: {
            fontSize: 20
          },
          className: "fa fa-spinner fa-spin"
        }),
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(step === 2 && !!pageInstagram || step === 1 && !pageInstagram)) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 3;
                  return handleAccountLoad();

                case 3:
                  return _context.abrupt("return", _context.sent);

                case 4:
                  if (!(step === 3 && !!enteredAccount)) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 7;
                  return onFinish(enteredAccount);

                case 7:
                  return _context.abrupt("return", _context.sent);

                case 8:
                  return _context.abrupt("return", incrementStep());

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      })].concat(_toConsumableArray(step === 1 && !!pageInstagram ? [/*#__PURE__*/React.createElement(RaisedButton, {
        key: "ig-diff-account",
        label: "Use Different Account",
        onClick: function onClick() {
          return skipToStep(2);
        },
        style: {
          marginRight: 12
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        key: "ig-existing-account",
        label: !loading ? 'Use This Account' : /*#__PURE__*/React.createElement("i", {
          style: {
            fontSize: 20
          },
          className: "fa fa-spinner fa-spin"
        }),
        disabled: loading,
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return onFinish({
                    image: pageInstagram.avatarImageUrl,
                    username: pageInstagram.username,
                    url: pageInstagram.link
                  });

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))
      })] : [])).filter(function (a) {
        return a;
      }),
      autoScrollBodyContent: true,
      modal: true,
      open: open,
      onRequestClose: onRequestClose,
      bodyStyle: {
        color: '#717171',
        lineHeight: '24px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.postReminderWrap
    }, step === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Grow your Instagram audience in 3 easy steps!"), ",", /*#__PURE__*/React.createElement("ol", {
      className: styles.postReminderIntroList
    }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("img", {
      src: "https://likeablelocal.s3.us-east-2.amazonaws.com/resources/calendar.svg"
    }), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("strong", null, "1."), " Schedule Content"), /*#__PURE__*/React.createElement("span", null, "Craft and Schedule meaningful content to share with your audience!")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("img", {
      src: "https://likeablelocal.s3.us-east-2.amazonaws.com/resources/letter.svg"
    }), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("strong", null, "2."), " Check Your Email"), /*#__PURE__*/React.createElement("span", null, "When it is time to post, we send you everything you need to submit to Instagram!")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("img", {
      src: "https://likeablelocal.s3.us-east-2.amazonaws.com/resources/instagram.svg"
    }), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("strong", null, "3."), " Post To Instagram"), /*#__PURE__*/React.createElement("span", null, "Grow your Instagram audience by posting reguarly!")))), step === 1 && !!pageInstagram && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Instagram Ads Account Already Connected"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement("p", null, "You already have an Instagram Ads Account, would you like to use this account?"), /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(ListItem, {
      style: {
        fontWeight: 'bold'
      },
      disabled: true,
      leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
        src: pageInstagram.avatarImageUrl
      }, !pageInstagram.avatarImageUrl ? makeInitials("".concat(pageInstagram.username)) : null)
    }, pageInstagram.username)))), (step === 2 || step === 1 && !pageInstagram) && [/*#__PURE__*/React.createElement("h2", {
      key: "enterheader"
    }, "Enter your Instagram Account"), /*#__PURE__*/React.createElement("div", {
      key: "enterbody",
      style: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement("p", null, "Please enter your Instagram username or URL to your Instagram account."), /*#__PURE__*/React.createElement(TextField, {
      name: "igusername",
      value: accountValue,
      onChange: onChangeAccount,
      placeholder: "Instagram Username",
      fullWidth: true
    }))], step === 3 && !!enteredAccount && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Enable Reminders For This Account?"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(ListItem, {
      style: {
        fontWeight: 'bold'
      },
      disabled: true,
      leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
        src: enteredAccount.image
      }, !enteredAccount.image ? makeInitials("".concat(enteredAccount.username)) : null)
    }, enteredAccount.username))))));
  },
  PostReminderSettings: function PostReminderSettings(_ref16) {
    var open = _ref16.open,
        loading = _ref16.loading,
        account = _ref16.account,
        onRequestClose = _ref16.onRequestClose,
        notifiableContacts = _ref16.notifiableContacts,
        manualEmailValue = _ref16.manualEmailValue,
        handleManualEmailValueChanged = _ref16.handleManualEmailValueChanged,
        handleAddManualEmail = _ref16.handleAddManualEmail,
        onChange = _ref16.onChange,
        selected = _ref16.selected,
        isSMB = _ref16.isSMB,
        reminder = _ref16.reminder,
        onFinish = _ref16.onFinish;
    return /*#__PURE__*/React.createElement(Dialog, {
      contentStyle: {
        transform: 'none'
      },
      repositionOnUpdate: false,
      style: {
        paddingTop: 16
      },
      title: "Post Reminder Settings",
      titleStyle: {
        color: '#555555'
      },
      actions: [/*#__PURE__*/React.createElement(RaisedButton, {
        key: "closebtn",
        label: "Close",
        onClick: onRequestClose,
        style: {
          marginRight: 12
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        key: "continuebtn",
        label: loading ? /*#__PURE__*/React.createElement("i", {
          style: {
            fontSize: 20
          },
          className: "fa fa-spinner fa-spin"
        }) : 'Save',
        disabled: loading,
        onClick: onFinish,
        style: {
          marginRight: 12
        }
      })],
      autoScrollBodyContent: true,
      modal: true,
      open: open,
      onRequestClose: onRequestClose,
      bodyStyle: {
        color: '#717171',
        lineHeight: '24px'
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        margin: '24px 0',
        color: '#333333',
        paddingBottom: 24,
        borderBottom: '1px solid rgba(87,87,87,0.2)'
      }
    }, "We will automatically send a reminder email to these users when an Instagram post should be submitted."), selected && !selected.length && /*#__PURE__*/React.createElement("div", {
      style: {
        margin: '24px 0',
        color: 'red'
      }
    }, "No users selected."), /*#__PURE__*/React.createElement(UserEmailSelector, {
      isSMB: isSMB,
      defaultValue: _toConsumableArray(account && account.PostReminders && account.PostReminders.length > 0 ? _toConsumableArray(account.PostReminders).reduce(function (acc, obj) {
        if (obj.PostReminderSubscriptions && obj.PostReminderSubscriptions.length > 0) {
          return acc.concat(obj.PostReminderSubscriptions.map(function (s) {
            return s.emailAddress;
          }));
        }

        return acc;
      }, []) : []),
      onChange: onChange,
      notifiableContacts: notifiableContacts,
      manualEmailValue: manualEmailValue,
      handleManualEmailValueChanged: handleManualEmailValueChanged,
      handleAddManualEmail: handleAddManualEmail
    })));
  },
  AccountSettings: function AccountSettings(_ref17) {
    var open = _ref17.open,
        account = _ref17.account,
        organization = _ref17.organization,
        onRequestClose = _ref17.onRequestClose;
    var dispatch = useDispatch();

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isLoading = _useState2[0],
        setIsLoading = _useState2[1];

    var _useState3 = useState(null),
        _useState4 = _slicedToArray(_useState3, 2),
        previewDataUrl = _useState4[0],
        setPreviewUrl = _useState4[1];

    var gmbAccountData = useSelector(function (state) {
      var _state$googleMyBusine, _state$googleMyBusine2;

      return (account === null || account === void 0 ? void 0 : account.platform) === 'Google my business' ? (_state$googleMyBusine = state.googleMyBusiness) === null || _state$googleMyBusine === void 0 ? void 0 : (_state$googleMyBusine2 = _state$googleMyBusine.businessInfoByLocation) === null || _state$googleMyBusine2 === void 0 ? void 0 : _state$googleMyBusine2["".concat(account.platformId)] : null;
    });
    useEffect(function () {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$dispatch, _previewDataUrl;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!open) {
                  _context3.next = 17;
                  break;
                }

                if (!(account.platform === 'Google my business')) {
                  _context3.next = 17;
                  break;
                }

                _context3.prev = 2;
                setIsLoading(true);
                _context3.next = 6;
                return dispatch(loadBusinessInfo(organization.id));

              case 6:
                _yield$dispatch = _context3.sent;
                _previewDataUrl = _yield$dispatch.data.previewDataUrl;
                setPreviewUrl(_previewDataUrl);
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](2);
                console.error(_context3.t0);

              case 14:
                _context3.prev = 14;
                setIsLoading(false);
                return _context3.finish(14);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 11, 14, 17]]);
      }))();
    }, [open]);
    var modalBody = null;
    var modalTitle = null;
    console.log('account settings', account);
    console.log('gmbAccountData', gmbAccountData);

    var periodsOnDay = function periodsOnDay(day) {
      var _gmbAccountData$regul;

      return _toConsumableArray((gmbAccountData === null || gmbAccountData === void 0 ? void 0 : (_gmbAccountData$regul = gmbAccountData.regularHours) === null || _gmbAccountData$regul === void 0 ? void 0 : _gmbAccountData$regul.periods) || []).filter(function (p) {
        return p.openDay === day;
      });
    };

    var formatOpenAndClose = function formatOpenAndClose(open, close) {
      var m1 = moment("1970-01-01 ".concat(open));
      var m2 = moment("1970-01-01 ".concat(close));
      return "".concat(m1.format('h:mm a'), "-").concat(m2.format('h:mm a'));
    };

    if (account) {
      switch (account.platform) {
        case 'Google my business':
          modalTitle = gmbAccountData === null || gmbAccountData === void 0 ? void 0 : gmbAccountData.locationName;
          modalBody = /*#__PURE__*/React.createElement(GMBSettings, {
            account: account,
            isLoading: isLoading,
            gmbAccountData: gmbAccountData,
            formatOpenAndClose: formatOpenAndClose,
            periodsOnDay: periodsOnDay
          });
          break;

        default:
          break;
      }
    }

    return /*#__PURE__*/React.createElement(Modal, {
      actions: !!gmbAccountData ? [/*#__PURE__*/React.createElement(RaisedButton, {
        href: account === null || account === void 0 ? void 0 : account.link,
        target: "_blank",
        label: "View on Maps",
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        href: gmbAccountData === null || gmbAccountData === void 0 ? void 0 : gmbAccountData.searchUrl,
        target: "_blank",
        label: "View on Search"
      })] : null,
      open: open,
      onRequestClose: onRequestClose,
      title: modalTitle
    }, modalBody);
  }
};